import { MAX_DOCUMENT_SIZE_BYTES } from './constants'

export function isFileTooLarge(
  file: Pick<File, 'size'>,
  maxBytes = MAX_DOCUMENT_SIZE_BYTES
) {
  return file.size > maxBytes
}

export function getFileSizeLimitMb(maxBytes = MAX_DOCUMENT_SIZE_BYTES) {
  return Math.ceil(maxBytes / (1024 * 1024))
}
